<template lang="pug">
  div(:class="b()")
    template(v-if="progress === 100")
      span.has-text-primary Completaste&nbsp;
      span el formulario
    template(v-else)
      div(:class="b('text')")
        span.has-text-primary {{ minutes }} minuto{{ minutes > 1 ? 's' : ''}}
        span  para pre-calificarte y ver propuestas
</template>

<script>
  const COMPLETE_MINUTES = 3;

  export default {
    name: 'time-remaining',

    props: {
      progress: { type: Number, default: 1 },
    },

    computed: {
      minutes() {
        return Math.round(((100 - this.progress) / 100) * COMPLETE_MINUTES) || 1;
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .time-remaining
    display: flex
    align-items: center
    justify-content: center
    padding-left: 1rem
    padding-right: 1rem
    font-size: 12px

    +tablet
      font-size: 14px
</style>